module.exports = __webpack_public_path__ + "img/20190826133246341.e7a1fc30.jpg";